import React, { memo } from 'react';

import styles from './AppPrompt.module.less';
import AppIcon from '../../../../static/order_app_icon.png';

export default memo(() => {
  const handleLink = () => {
    window.open('https://hd.lenovomm.com/front-agreement/agreement/refundExplain');
  };

  return (
    <div className={styles.app_prompt}>
      <div className={styles.app_prompt_icon}>{/* <img src={AppIcon} /> */}</div>
      <div className={styles.app_prompt_message}>
        <span>无理由退款服务仅支持标有无忧退标识的应用，退款规则详见：</span>
        <span className={styles.app_prompt_link} onClick={handleLink}>
          《联想应用商店7日无理由退货规则说明》
        </span>
      </div>
    </div>
  );
});
